
import React, { Component } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { get, post, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import '../adminDash.css';
import globalVariables from "../../custom_libraries/globalVariables";
import withNavigate from "../../Global_files/WithNavigate";

import Navigationbar from '../Navigationbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIcon from '@mui/icons-material/Cancel';
import Tooltip from '@mui/material/Tooltip';
//import mui components to inhance the look
import { Button, Snackbar, Alert } from '@mui/material';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
// import BusinessIcon from '@mui/icons-material/Business';
// import MapIcon from '@mui/icons-material/Map';
import MoreVertIcon from "@mui/icons-material/MoreVert";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,

  TextField,
  IconButton,
  Typography,
  Box, Menu, MenuItem 
} from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import LiveTvIcon from '@mui/icons-material/LiveTv';
import CancelIcon from '@mui/icons-material/Cancel';
// import StorageIcon from '@mui/icons-material/Storage';
import LinkIcon from '../../assets/ip-globe-icon.png';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import FolderIcon from '@mui/icons-material/Folder';
// import VideocamIcon from '@mui/icons-material/Videocam';
// import DvrIcon from '@mui/icons-material/Dvr';
// import DnsIcon from '@mui/icons-material/Dns';
import DeviceIcon from '../../assets/icons8-bullet-camera-gray-24 .png'
// import SyncIcon from '../../assets/icons8-synchronize-48.png';
import SyncIcon from '../../assets/icons8-synchronize-96.png';
// import { Link } from 'react-router-dom';
import DialogBox from '../DialogBox';
import { DateTime } from "luxon";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import passwordEye from '../../assets/icons8-eye-64.png';
import LinearProgress from '@mui/material/LinearProgress';
// import { startWebSocketServer } from "../../../backend/server"; // Import server.js
// const { startServer } = window.require("../backend/preload.js");
// import { spawn, exec } from "child_process";


class ShowDevices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSite: null,
      selectedSiteInfo: null, 
      cameras: [],
      devices: [],
      searchInput: "",
      currentPage: 1,
      rowsPerPage: 5,
      device_details: [],

      expandedRow: null, // Track which row is expanded
      nestedExpandedRow: null,
      ref_img_created_time: null,
      ref_img_next_inspection: "",
      latest_img_taken_at: null,
      capturedImageBlob: null,
      capturedLatestImageBlob: null,
      currentTime_of_device: null,
      selectedCamera: null,
      isPopupVisible: false,
      activeSection: 'reference',	// State to track the active collapsible section

      deviceId: '',
      snackbar_msg: '',
      open_snackbar: false,

      confirmDialog: {
        isOpen: false,
        title: '',
        subtitle: '',
      },

      open_MuteUnmute_Dialogue: false,
      mute: false,
      selectedCameraId: null,
      muteResponseMessage: '',
      error2: false,
      success2: false,
      success: false,

      image1: '',
      ref_img_id: null,
      image2: '',

      site_list: [],
      filteredDevices: [], // Devices to display based on filter

      refreshSystemOverviewstatuscard: false,

      //add site----
      toggleAddSite: false,
      sitename: '',
      address: '',
      city:'',
      street:'',
      zip:'',
      country:'',
      state:'',
      organisationName: '',
      warning_site: false,
      success_site: false,
      error_site: false,
      open_progress_bar: false,
      open_progress_bar1:false,
      user_name:'',
      user_type:'',
      client_list:[],
      selected_Customers:[],
      //--edit site--------
      editToggle: false,
      siteid: '',
      organisation_name: '',
      edit_sitename: '',
      edit_address: '',
      edit_city : "",
      edit_zip : "",
      edit_state : "",
      edit_country : "",
      edit_organisation_name: '',
      edit_selected_Customers_list:[],
      toggleAddDevice : false,

      //-----Add Device
      deviceName :'',
      deviceType : '',
      client :'',
      ipAddress : null,
      protocol : '',
      portNumber : null,
      rtsp_port : null,
      deviceUsername : '',
      devicePassword : '',
      warning_device : false,
      warning1_device : false,
      error_device : false,
      error1_device : false,
      success_device : false,
      //site_list,
      device_type_list  : [],
      showModal : false,
      showTestModal : false,
      responseMessage : "", 
      response_data  : {},
      anchorEl: null,
      anchorE2:null,

      //--edit device
      editDeviceToggle:false,
      Selected_Device_Id : '',
      EditDeviceName: "",
      EditDeviceType: "", // default null to select from list of valid options only
      EditIpAddress: "",
      EditProtocol: "",
      EditPortNumber: "",
      EditDeviceUsername: "",
      EditDevicePassword: "",
      success_device_edit: false,
      error_device_edit : false,
      error: false,
      passwordShown:false,

      //--Add group---
      anchorE3:null,
      AddGroupToggle:false,
      group_name: '',
      parent_group: '',

      //-- add device polling
      ws: null,
      taskQueue: [],
      currentTaskIndex: 0,
      taskStatus: [],
      taskResults: {},
      taskIds:{},
      stopProcessing: false,          // Stops further execution if first task fails
      notFoundCount:0,
      channelList:[],
      final_channel_list:[],
      loading: true,
      showDiskDetails:false,

      // serverProcess: null, // To store the server process instance
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    
    // startWebSocketServer(); // Start WebSocket Server Automatically
    this.connectWebSocket(); // Connect to WebSocket
    this.getSitesList();
    //Add site---------
    this.setState({ user_name : localStorage.getItem(globalVariables.USER_NAME)});
            //  const timezones = moment.tz.names();
            // this.setState({ timezones });
            const user_type = localStorage.getItem(globalVariables.USER_TYPE);
            this.setState({ user_type }, () => {
            this.getCustomerList(); // Ensure this runs after state is updated
    });
    //----------Add device---------
    this.fetchDeviceTypes();

    // Add event listener for keydown
    document.addEventListener("keydown", this.handleKeyDown);
  }

  validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);
      
          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
        }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning_device !== prevState.warning_device ||
        this.state.error_device !== prevState.error_device ||
        this.state.error1_device !== prevState.error1_device ||
        this.state.warning1_device !== prevState.warning1_device ||
        this.state.success_device !== prevState.success_device ||
        this.state.success !== prevState.success ||
        this.state.error !== prevState.error 
    ) {
        if (
            this.state.warning_device ||
            this.state.error_device ||
            this.state.error1_device ||
            this.state.warning1_device ||
            this.state.success_device ||
            this.state.success ||
            this.state.error
        ) {
            setTimeout(() => {
                this.setState({
                    warning_device: false,
                    error_device: false,
                    error1_device: false,
                    warning1_device: false,
                    success_device: false,
                    success: false,
                    error : false
                });
            }, 4000); // 1 second
        }
    }
}

  componentWillUnmount() {
    // Remove event listener for keydown
    document.removeEventListener("keydown", this.handleKeyDown);
    //polling
    if (this.state.ws) {
      this.state.ws.close();
    }
  }

  // startServerAndConnect = async () => {
  //   startServer(); // ✅ Start `server.js`
  //   this.connectWebSocket(); // ✅ Connect WebSocket
  // };

  // Function to Start WebSocket Server
  // startServer = () => {
  //   if (!this.state.serverProcess) {
  //     console.log("🚀 Starting WebSocket server...");
  //     const serverProcess = spawn("node", ["backend/server.js"], { detached: true });

  //     serverProcess.stdout.on("data", (data) => console.log(`Server: ${data}`));
  //     serverProcess.stderr.on("data", (data) => console.error(`Server Error: ${data}`));

  //     this.setState({ serverProcess }, () => {
  //       this.connectWebSocket();
  //     });
  //   }
  // };

  // Function to Stop WebSocket Server
  // stopServer = () => {
  //   if (this.state.serverProcess) {
  //     console.log("🛑 Stopping WebSocket server...");
  //     exec("pkill -f backend/server.js", (err) => {
  //       if (err) console.error("Error stopping server:", err);
  //       else console.log("✅ Server stopped successfully");
  //     });
  //     this.setState({ serverProcess: null });
  //   }
  // };

  //on ecs keyboard key press, close the dialogue box
  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // Close modal when Esc key is pressed
      this.handleCloseModal();
    }
  };

  /** 
   * getCamerasList() function fetches the camera list w.r.t selected device (row from device list table). this function gets invoked from when clicked on the row of device list table.
  **/
  getCamerasList = async (deviceId) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("komal -------------->:", this.state.device_details.recording_policy_days);
      //this.setState({ : [] }); 

      const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
      const response = await get(url, headers); // Perform the API call using the constructed URL
      if (Array.isArray(response) && response.length > 0) {
        console.log(`API Response for device ${deviceId}:`, response);
        this.setState({ cameras: response });

      } else {
        console.error("No valid data returned from the get-camera API");
        this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
      this.setState({ cameras: [] }); // Clear the cameras list in case of error
    }
  };

  handleSiteSelection = (siteId, siteInfo) => {
    this.setState({ selectedSite: siteId, selectedSiteInfo: siteInfo });
    // localStorage.setItem(globalVariables.SITE_ID, siteId);
    this.getDevicesListById(siteId);
  };

  deviceSync = async () => {
    
    const{selectedSite}=this.state
    console.log("-----deviceSync----selectedSite", selectedSite);
    this.startLoading();
    // Delay for alert visibility before reload
    setTimeout(() => {
      this.getDevicesListById(selectedSite).then(() => {
          this.stopLoading(); // Stop loading after devices are fetched
      });
  }, 500); // Ensures progress bar is visible before stopping
  }
  

  getDevicesListById = async (site_id) => {
    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }
      const response = await get(urls.GET_DEVICES_BY_SITE(site_id), headers); //  API call to get the devices list w.r.t selected client
      console.log("API Response:---getDevicesListById---------------------------------------->>>", response)

      if(response.detail==="No devices found for this site.")  
      {
        this.setState({ 
          devices: [], loading: false });
        return
      }
      if (response) {
        console.log("res", response)
        this.setState({loading: false, devices: response });
        // this.setState({ devices:deviceData });
        // this.setState({ deviceId:deviceData.id });
      } else {
        console.error("No data returned from the API");
      }
    } catch (error) {
      console.error("Error fetching devices from API:", error);
    }
  };


  getSitesList = async () => {
    try {
      this.startLoading();
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_tocken}`
      }

      console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
      const response = await get(urls.GET_SITES_BY_USER, headers);
      console.log("response sites array ===> ", response);
      this.stopLoading();
      if (!response) {
        console.error("Failed to fetch site list.");
        this.setState({ site_list: [] });
        return;
      }

      this.setState({ site_list: response, edit_selected_Customers_list: response.users || [], });
    } catch (error) {
      console.error("Error in getSitesList:", error);
      this.setState({ site_list: [] });
    }
  };

  handleChangePage = (newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };



  // Handler to toggle dropdown table for a device row
  handleRowClick = async (deviceId) => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    console.log("--------auth tocken---------", access_tocken);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    let device_details = await get(urls.DEVICE_DETAILS(deviceId), headers)

    console.log("device_Details", device_details)

    this.setState({
      device_details: device_details
    })


    this.setState(
      (prevState) => ({
        expandedRow: prevState.expandedRow === deviceId ? null : deviceId, // Toggle the row
      }),
      () => {
        if (this.state.expandedRow) {
          this.getCamerasList(deviceId); // Fetch data only when the row is expanded
        }
      }
    );
  };



  // closePopup = () => {
  //   this.setState((prevState) => {
  //     console.log("Toggling refreshSystemOverviewstatuscard:", !prevState.refreshSystemOverviewstatuscard);
  //     return {
  //       isPopupVisible: false,
  //       selectedCamera: null,
  //       refreshSystemOverviewstatuscard: !prevState.refreshSystemOverviewstatuscard,
  //     };
  //   });
  // };

  // Toggle collapsible function
  handleToggle = (section) => {
    this.setState((prevState) => ({
      activeSection: prevState.activeSection === section ? null : section,
    }));
  };



  handleCameraSchedule = (deviceId) => {
    console.log("handleCameraSchedule---cameraId---", deviceId)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    //navigate to system-manager/scheduler by navigation
    this.props.navigate("/system-overview/scheduler");
  }

  handleAboutDeviceNavigation = (deviceId, SiteName, DeviceName) => {
    console.log("handleCameraSchedule---cameraId---", deviceId)
    localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
    localStorage.setItem(globalVariables.SITE_NAME, SiteName);
    localStorage.setItem(globalVariables.DEVICE_NAME, DeviceName);
    this.props.navigate("/aboutDevice");
  }

  handleSiteFilterChange = (event) => {
    const selectedSite = event.target.value;
    this.setState({ selectedSite });

    console.log("----selected site to filter devices ----", selectedSite);

    if (selectedSite === "Show all/remove filter") {
      this.setState({ filteredDevices: this.state.devices });
      console.log("----filteredDevices ----", this.state.filteredDevices);
    } else {
      const filteredDevices = this.state.devices.filter((device) => {
        console.log("Comparing:", device.site_name, "with", selectedSite);
        return device.site_name === selectedSite;
      });

      this.setState({ filteredDevices });
      console.log("----filteredDevices ----", this.state.filteredDevices);
    }
  };


  // ---------------------------Add Site Functions---------------------------------------------------------
      
    getCurrentTimeInDeviceTimezone = (timezone ) => {
      try {

      //   if (!timezone || timezone === "Address not found") {
      //     return "Timezone Unavailable"; // Prevent error
      // }
          // Get the current time in the specified timezone
          const localTime = new Intl.DateTimeFormat("en-US", {
              timeZone: timezone,
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true, // Use 12-hour format
          }).format(new Date());
  
          return localTime;
      } catch (error) {
          console.error("Error calculating device time:", error);
          return "Error calculating time";
      }
  };
  
  getCurrentTimeInPosixTz = (posixTz) => {
    try {
        if (!posixTz) return "-";
  
        // Convert POSIX to IANA timezone (e.g., EST5EDT -> America/Detroit)
        const ianaTimezone = "America/Detroit"; // Manually mapping for accuracy
  
        // Get the current time in that timezone
        const dt = DateTime.now().setZone(ianaTimezone);
  
        // Format: "7/2/2025 at 08:30 AM"
        const formattedTime = dt.toFormat("MM/dd/yyyy',' hh:mm a");
  
        return formattedTime;
    } catch (error) {
        console.error("Error calculating time:", error);
        return "Error calculating time";
      }
  };

  NavigateToAddSIte = () => {
        this.setState({toggleAddSite: true})
      }

      closePopup = () => {
        this.setState({ toggleAddSite: false, toggleAddDevice: false, editDeviceToggle:false, AddGroupToggle:false });
      };
  
      handleInputChange = (e) => {
          const { name, value } = e.target;
          this.setState({ [name]: value });
      };
  
      getCustomerList = async () => {
          console.log("Fetching data from:", urls.GET_USERS);
          const {user_type} = this.state
          console.log("----user_type----", user_type);
          try {
              let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
              
              
              console.log("--------auth token---------", access_token);
              let headers = {
                  "content-type": "application/json",
                  Authorization: `Bearer ${access_token}`
              };
              if (user_type === "DealerUser"){
                  let dealer_id = localStorage.getItem(globalVariables.USER_ID);
                  console.log("--------dealer_id---------", dealer_id);
                  let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_id);
                  console.log("--------url---------", url);
                  const response = await get(url, headers); // API call
                  console.log("--------response---------", response);
  
                  // Validate the response and extract results
                  if (!response || !response.results || !Array.isArray(response.results)) {
                      console.error("Invalid response or results:", response);
                      this.setState({ client_list: [] });
                      return;
                  }
                  this.setState({ client_list: response.results });
                  console.log("user_list---------", this.state.client_list);
              }
              if (user_type === "TechnicianUser"){
                  let dealer_uuid = localStorage.getItem(globalVariables.DEALER_UUID);
                  console.log("--------dealer_uuid---------", dealer_uuid);
                  let url = urls.GET_USER_LIST_WITH_PERMISSIONS(dealer_uuid);
                  console.log("--------url---------", url);
                  const response = await get(url, headers); // API call
                  console.log("--------response---------", response);
  
                  // Validate the response and extract results
                  if (!response || !response.results || !Array.isArray(response.results)) {
                      console.error("Invalid response or results:", response);
                      this.setState({ client_list: [] });
                      return;
                  }
                  this.setState({ client_list: response.results });
                  console.log("user_list---------", this.state.client_list);
              }
          } catch (error) {
              console.error("Error in getCustomerList:", error);
              this.setState({ client_list: [] });
          }
      };
      
      handleSelectionChange = (event) => {
          // const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
          // console.log("Selected Customers:", selectedOptions);
          // this.setState({ selected_Customers: selectedOptions });

          const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
          // Find the selected customers from the client_list based on the selected user IDs
        const selectedUsers = this.state.client_list.filter(user => selectedOptions.includes(user.user_id));
        console.log("selected users",selectedUsers)
        // Update the selected_Customers state
        this.setState({ edit_selected_Customers_list: selectedUsers });
      };
  
      handleSiteSave = async () => {
          const { sitename, city, street, zip, organisationName, country, state, selected_Customers } = this.state;
          // const address = `${street}, ${city}, ${zip}, ${state}, ${country}`;

          // Ensure blank values are preserved in the output
          const address = [street || "", zip || "", city || "", state || "", country || ""].join(", ");
          
          // Validation for required fields
          if (!sitename || !organisationName || !address) {
              this.setState({ warning_site: true });
              return;
          }
  
          let updatedSelectedCustomers = [...selected_Customers];
          updatedSelectedCustomers = [localStorage.getItem(globalVariables.USER_ID), ...updatedSelectedCustomers];  // Prepend logged-in user
          
  
          const data = JSON.stringify({
              sitename,
              address,
              organisation_name: organisationName,
              users: updatedSelectedCustomers,
          });
  
          console.log("Data to be saved:", data);
          this.startLoading()
          try{
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
              console.log("--------auth tocken---------", access_tocken);
              let headers = {
                  // 'content-type': 'application/json',
                  'Content-Type': 'application/json; charset=UTF-8',
                  'Authorization': `Bearer ${access_tocken}`
              }
              const response = await post(urls.SITE_MANAGE, data, headers);
  
              console.log("reposne of const===> ", response);
              if (response) {
                      this.setState({ success_site: true });
                  
                  //Delay for alert visibility before reload
                  setTimeout(() => {
                      window.location.reload();
                  }, 1500);
              }
              else{
                  console.error('Error:');
                  this.setState({ error_site: true });
              }
          }
          catch (error) {
              console.error('Error:', error);
              this.setState({ error_site: true});
          }
          this.stopLoading()
      };
  
      startLoading = () => {
          console.log("startloading")
      
          this.setState({ open_progress_bar: true })
      }
      
      stopLoading = () => {
          this.setState({ open_progress_bar: false })
      }

      startLinearLoading = () => {
        console.log("startloading")
    
        this.setState({ open_progress_bar1: true })
    }
    
    stopLinearLoading = () => {
        this.setState({ open_progress_bar1: false })
    }

  //-------------------------------------------------------------------------------------------------------

  //------------------------------Edit site Info ----------------------------------------------------------
  handleEdit = async () => {
        this.setState({ anchorEl: null, editToggle: true });
        const {selectedSite} = this.state
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            console.log("--------auth tocken---------", access_tocken);
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.SITE_MANAGE_ID(selectedSite);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);

            const response = await get(url, headers); // Perform the API call using the constructed URL

            console.log(`API Response for LoadSelectedDeviceInfo ${selectedSite}:`, response);

            if (response && Object.keys(response).length > 0) {
                console.log(`API Response for LoadSelectedDeviceInfo ${selectedSite}:`, response);

                //Extract address fields by splitting
                let addressParts = response.address ? response.address.split(",") : [];
                
                // Extracting address components
                let street = addressParts.slice(0, -4).join(",").trim() || ""; // Everything before last 4 elements is street
                let city = addressParts.at(-3)?.trim() || ""; // Fourth last element is city
                let zip = addressParts.at(-4)?.trim() || ""; // Third last element is zip
                let state = addressParts.at(-2)?.trim() || ""; // Second last element is state
                let country = addressParts.at(-1)?.trim() || ""; // Last element is country

                this.setState({
                  edit_sitename: response.sitename || "",
                  edit_organisation_name: response.organisation_name || "",
                  // edit_address: response.address || "",
                  edit_selected_Customers_list: response.users || [],  // Populate selected_Customers with the users list from the response
                  edit_address: street || "",
                  edit_city : city || "",
                  edit_zip : zip || "",
                  edit_state : state || "",
                  edit_country : country || ""
                  // selectedSiteInfo: response,
                });

            } else {
                console.error("No valid data returned from the get-camera API");
                // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
            }
        } catch (error) {
            console.error("Error fetching cameras from API:", error);
            // this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
    };

  handleEditSave = async () => {
        console.log("handle edit save");
        const {selectedSite} = this.state
        const { edit_sitename, edit_organisation_name, edit_address, edit_selected_Customers_list, edit_city, edit_zip, edit_country, edit_state, } = this.state;

        // Ensure blank values are preserved in the output
          const address = [edit_address || "", edit_zip || "", edit_city || "",  edit_state || "", edit_country || ""].join(", ");
          console.log("address", address);
        if (!edit_sitename || !edit_organisation_name || !edit_address) {
            this.setState({ warning: true });
            return;
        }
    
        const loggedInUserId = localStorage.getItem(globalVariables.USER_ID);
        const userIds = edit_selected_Customers_list.map(customer => customer.user_id);
    
        if (loggedInUserId) {
            userIds.push(loggedInUserId);
        }
        console.log("User IDs:", userIds);

        // Ensure timezone is valid before sending to backend
        let validTimezone = selectedSite?.timezone;
        if (!validTimezone || validTimezone === "Address not found") {
            validTimezone = "UTC"; // Default fallback
        }
    
        const data = JSON.stringify({
          sitename: edit_sitename,
          address: address,
          organisation_name: edit_organisation_name,
          users: userIds,
        });
    
        console.log("Data to be saved:", data);
    
        try {
          this.startLoading();
            const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
            const headers = {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${access_token}`,
            };
    
            console.log("API URL:", urls.SITE_UPDATE_CUSTOM(selectedSite));
    
            const response = await fetch(urls.SITE_UPDATE_CUSTOM(selectedSite), {
                method: 'POST',
                headers,
                body: data,
            });
            this.stopLoading();
            if (!response.ok) {
                const errorResponse = await response.json();
                console.error("API Error Response:", errorResponse);
                throw new Error(`API Error: ${response.status} ${response.statusText}`);
            }
    
            const result = await response.json();
            console.log("Response from backend:", result);
    
            this.setState({ success: true });
            setTimeout(() => {
                this.setState({editToggle:false})
                window.location.reload();
                
            }, 3000);
        } catch (error) {
            console.error("Error:", error);
            this.setState({ error: true });
        }
    };

  closeEditPopup = () => {
      this.setState({ editToggle: false });
  };

  handleEditSelectionChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, option => option.value);
    
    // Find the selected customers from the client_list based on the selected user IDs
    const selectedUsers = this.state.client_list.filter(user => selectedOptions.includes(user.user_id));
    console.log("selected users",selectedUsers)
    // Update the selected_Customers state
    this.setState({ edit_selected_Customers_list: selectedUsers });
};
  //-------------------------------------------------------------------------------------------------------

  //-----------------------------Add Device functions ----------------------------------------------------

  NavigateToAddDevice = () => {
    this.setState({toggleAddDevice: true})
  }

  fetchDeviceTypes = async () => {
          try {
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
              console.log("--------auth tocken---------", access_tocken);
              let headers = {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${access_tocken}`
              }
              console.log("Fetching data from:", urls.DEVICE_TYPE_LIST);
              const response = await get(urls.DEVICE_TYPE_LIST, headers);
              console.log("Client list Response in Adddevice-----:", response);
      
              if (!response || !Array.isArray(response)) {
                  console.error("Invalid response format or empty list.");
                  this.setState({ device_type_list: [] });
                  return;
              }
      
              this.setState({ device_type_list: response }); // Directly use the array from your response
              console.log("Updated state with device types list:", this.state.device_type_list);
          } catch (error) {
              console.error("Error in fetchDeviceTypes:", error);
              this.setState({ device_type_list: [] });
          }
  }


   // Handle device add form submission -----------------------------------------
   connectWebSocket = () => {
  //  const{notFoundCount} = this.state
    const ws = new WebSocket("ws://localhost:8080");
    ws.onopen = () => {
        console.log("✅ WebSocket connected");
        this.setState({ ws});
    };
    ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("🔍 WebSocket message received:", message);
  
      const { currentTaskIndex, taskQueue, taskStatus, stopProcessing } = this.state;
  
      if (currentTaskIndex >= taskQueue.length) {
          console.error("⚠️ No task at index:", currentTaskIndex);
          return;
      }
  
      if (stopProcessing) {
          console.log("🚨 Processing stopped due to timeout. No further fetch requests.");
          return;
      }
  
      const taskId = taskQueue[currentTaskIndex];
  
      if (message.action === "task_result") {
          const task = message.task.data;
          
          if (!task) {
              console.error("❌ Invalid WebSocket response format: missing task object.");
              return;
          }
  
          // ✅ PENDING TASK CONDITION
          if (task.status === "PENDING") {
              console.log(`⏳ Task ${taskId} is still pending... retrying in 2s`);
  
              this.setState(prevState => ({
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? `⏳ Task is still in progress... retrying in 2s` : status
                  ),
                  open_progress_bar1: true
              }));
  
              setTimeout(() => {
                  this.fetchTask(taskId);
              }, 2000);
          }
          
          // ❌ FAILURE CONDITION
          else if (task.status === "FAILURE") {
              console.log(`❌ Task ${taskId} failed. Device might be unreachable.`);
  
              this.setState(prevState => ({
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? `❌ Failed to fetch info. Device might not be reachable.` : status
                  ),
                  open_progress_bar1: false,
                  taskResults: {} // Clear results to prevent rendering old data 
              }));
              return; // Stop further processing
          }
  
          // ✅ SUCCESS CONDITION
          else if (task.status === "SUCCESS") {
              console.log(`✅ Task ${taskId} completed successfully.`);
              
              this.setState(prevState => ({
                  taskResults: { ...prevState.taskResults, [task.task_id]: task.result },
                  taskStatus: prevState.taskStatus.map((status, index) =>
                      index === prevState.currentTaskIndex ? "✅ Task completed!" : status
                  ),
                  showModal: true, // Ensure modal is displayed when data arrives
                  currentTaskIndex: currentTaskIndex + 1,
                  open_progress_bar1: false
              }), () => this.processNextTask());
          }
      }
      
      // 🔍 TASK NOT FOUND CONDITION
      else if (message.action === "task_not_found") {
          console.log(`⏳ Task ${taskId} not found. Retrying...`);
  
          this.setState(prevState => ({
              taskStatus: prevState.taskStatus.map((status, index) =>
                  index === prevState.currentTaskIndex ? `Connection test has begun. \n Test is running! \n🔍 Retrying to fetch further information...` : status
              ),
              open_progress_bar1: true
          }));
  
          setTimeout(() => {
              this.fetchTask(taskId);
          }, 3000);
      }
    };
    ws.onerror = (error) => console.error("❌ WebSocket error:", error);
    ws.onclose = () => {
        console.log("🔌 WebSocket disconnected, retrying in 3s...");
        setTimeout(() => this.connectWebSocket(), 3000);
    };
    
    this.setState({ ws });  
    //websocket is closed in componentWillMount.
    };

  sendMessage = (data) => {
      const { ws } = this.state;
      if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
      } else {
          console.error("❌ WebSocket is not open");
      }
  };

  fetchTask = (taskId) => {
    const { taskStatus, currentTaskIndex } = this.state;
    taskStatus[currentTaskIndex] = `Connection test has begun \n Test is running! \n🔍 Fetching the Information...`;
    this.setState({ taskStatus, open_progress_bar1: true });
    
  //-----------------------------------------------
    if (taskId.trim()) {
        this.sendMessage({ action: "fetch_task", taskId });
    } else {
        console.log("Please enter a Task ID");
    }
};




  // Handle device add form submission2-------------------
  handleSubmit = async (e) => {
      e.preventDefault();
      this.startLoading();
      // this.startServer();
      console.log("----handleSubmit-----------");
      const {
          deviceName,
          deviceType,
          client,
          selectedSite,
          ipAddress,
          protocol,
          portNumber,
          deviceUsername,
          devicePassword,
          rtsp_port,
        } = this.state;

      // // Validation
      if (!deviceName || !selectedSite || !ipAddress) {
          this.setState({ warning_device: true});
          this.stopLoading()
          return;
      }

      // Prepare payload
      let deviceData = {
          device_name: deviceName,
          device_type: deviceType,
          sitedb: selectedSite,
          ip_address: ipAddress,
          protocol: protocol?.toLowerCase().replace('://', ''), // Convert to lowercase and remove '://'
          port_number: portNumber,
          device_username: deviceUsername,
          device_password: devicePassword,
          rtsp_port: rtsp_port,
          policy_template_id : "1",         
      };
      const data = JSON.stringify(deviceData);
      console.log("data---",data);

      try{
          const{selectedSite}= this.state
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          // console.log("--------auth tocken---------", access_tocken);
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          
          let response = await post(urls.ADD_DEVICE, data, headers)

          console.log("url",urls.ADD_DEVICE);
          console.log("data res",response);

          if(response !== false){
            if(response.responseMessage.includes("Device with IP") &&
            response.responseMessage.includes("already exists")){
                this.setState({ error1_device: true, responseMessage: response.responseMessage }, this.stopLoading);
                return;
            }
            else if(response.responseMessage === "Enter a valid IPv4 or IPv6 address."){
                this.setState({ error1_device: true, responseMessage: response.responseMessage }, this.stopLoading);
                return;
            }
          }

          // const response_data = await response.json();
          console.log("response data",response.taskIds);

          if (response.taskIds) {
              this.setState({
                          success: true,
                          showModal: true,
                          taskIds : response.taskIds
                          //responseMessage: response.responseMessage,
                          //response_data: response.response_data,
                      });
              const taskIds = Object.values(response.taskIds);
              const taskStatus = taskIds.map(() => "🔄 Waiting for task...");
              this.setState({ taskQueue: taskIds, currentTaskIndex: 0, taskStatus }, () => {
              this.processNextTask();
              });
          }
          
          // setTimeout(() => {  //TODO------------------------------verify if needed after testing 
          //   this.getDevicesListById(selectedSite)
          //   }, 4000); 
      }catch (error) {
          console.error('Error:', error);
          this.setState({ error_device: true });
      } finally {
          this.stopLoading();
          // this.stopServer();
      }
  };

  processNextTask = () => {
    const { taskQueue, currentTaskIndex, stopProcessing } = this.state;
    // Stop further execution if the first task failed
    if (stopProcessing) {
        console.log("⚠️ Stopping further task execution.");
        return;
    }
    if (currentTaskIndex < taskQueue.length) {
        this.fetchTask(taskQueue[currentTaskIndex]);
    } else {
        // this.setState(prevState => ({
        //     taskStatus: [...prevState.taskStatus, "🎉 All tasks processed!"],
        //     open_progress_bar1: false
        // }));
        this.setState(prevState => ({
          taskStatus: [...prevState.taskStatus, "🎉 All tasks processed!"],
          open_progress_bar1: false
      }), () => {
          console.log("✅ Progress bar hidden:", this.state.open_progress_bar1);
          let channel_list_final = this.state.channelList
          this.setState({final_channel_list: channel_list_final})
      });
    }
};
  
  // Method to handle modal close
  handleCloseModal = () => {
    const{selectedSite}= this.state
      this.setState({ showModal: false, showTestModal:false, toggleAddDevice:false }, () => {
          // Reload the page after modal is closed
          // window.location.reload();
          setTimeout(() => {  //TODO------------------------------verify if needed after testing 
            this.getDevicesListById(selectedSite);
            }, 1000);
      });
  };
  //-----------------------------------------------------------------------------------------------------

  // Handle opening the menu
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleDeviceKebabClick = (event) => {
    this.setState({ anchorE2: event.currentTarget });
  };

  handleGroupKebabClick = (event) => {
    this.setState({ anchorE3: event.currentTarget });
  };

  // Handle closing the menu
  handleClose = () => {
    this.setState({ anchorEl: null, anchorE2: null, anchorE3:null });
  };

  openDialog = (onConfirm) => {
    // const {selectedSite} = this.state
    this.setState({ anchorEl: null, anchorE2: null, anchorE3:null})
    console.log("---openDialog-------");
    this.setState({
      confirmDialog: {
        isOpen: true,
        title: 'Confirm Action',
        subtitle: "Are you sure, you want to delete the selected record?",
        onConfirm
      },
    });
  };

closeDialog = () => {
    this.setState({
      confirmDialog: {
        ...this.state.confirmDialog,
        isOpen: false,
      },
    });
  };

  handleDelete = async (siteId) => {
      // const userConfirmed = window.confirm('Are you sure you want to delete this site?');
      // if (!userConfirmed) return;
       const {selectedSite} = this.state
      console.log("--------selectedSite---------", siteId);
      try {
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          console.log("--------selectedSite---------", siteId);
          
          const response = await fetch(urls.SITE_MANAGE_ID(selectedSite), 
          { method: 'DELETE',
          headers : {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          });


          if (!response.ok) {
              // throw new Error(`Error: ${response.status}`);
              this.openSnackbar("Error occured while deleting Site!", "success");            
              return;
          }

          setTimeout(() => {
              // this.setState({success1 : true})
              this.openSnackbar("Site deleted successfully!", "success");
              // this.getSitesList()
              window.location.reload()
          }, 3000); // 2 seconds delay
      } catch (error) {
          console.error('Error deleting site:', error);
          alert('Failed to delete site. Please try again.');
      }
  };

  openSnackbar = (msg, alert_type = 'warning' || 'success' || 'error' || 'info') => {
    this.setState({
      open_snackbar: true,
      snackbar_msg: msg,
      alert_type: alert_type,
    })
  }

  // ------------------Test device connection--------------------------
    TestConnection = async ( device) => {
      this.setState({ anchorE2: null });
        // e.preventDefault();
        this.startLoading();
        // this.startServer();
        // Prepare payload
        let deviceData = {
          device_name: device.device_name,
          device_type: device.device_type,
          sitedb: device.sitedb,
          ip_address: device.ip_address,
          protocol: device.protocol, // Convert to lowercase and remove '://'
          port_number: device.port_number,
          device_username: device.device_username,
          device_password: device.device_password,
          rtsp_port: device.rtsp_port,
          policy_template_id: device.recording_policy
          };
          const data = JSON.stringify(deviceData)
          console.log("---TestConnection---data--",data);
  
  
        try{
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          // console.log("--------auth tocken---------", access_tocken);
          let headers = {
              // 'content-type': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': `Bearer ${access_tocken}`
          }
          // Call custom get method REFRESH_DEVICES
          let response = await post(urls.TEST_CONNECTION, data, headers)
          // let response = await post(urls.REFRESH_DEVICES, data, headers)
  
          console.log("url",urls.REFRESH_DEVICES)
          console.log("data res",response)
          this.stopLoading()
          if(response!==false)
              {
                if (response.taskIds) {
                  this.setState({
                              showTestModal: true,
                              taskIds : response.taskIds
                              //responseMessage: response.responseMessage,
                              //response_data: response.response_data,
                          });
                  const taskIds = Object.values(response.taskIds);
                  const taskStatus = taskIds.map(() => "🔄 Waiting for task...");
                  this.setState({ taskQueue: taskIds, currentTaskIndex: 0, taskStatus }, () => {
                  this.processNextTask();
                  });
              }
                  // this.setState({
                  //     success2_device: true,
                  //     showTestModal: true, // Show the modal
                      
                  // });
  
              }
              // else if(response === "Failed to fetch info from Device!" || response === false){
              //     this.setState({
              //       error2_device: true,
              //       showTestModal: true,
              //       });
              // }
              // setTimeout(() => {
              //   console.log("✅ Device operation completed");
              //   this.stopServer();
              // }, 10000);
          }catch (error) {
              console.error('Error:', error);
              // alert('An error occurred while creating the device.');
              // this.setState({ error: true});
          }
    };

    LoadSelectedDeviceInfo = async (deviceId) => {
      this.setState({anchorE2: null, editDeviceToggle: true });
      this.setState({Selected_Device_Id : deviceId})

      try {
        let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
        console.log("--------auth tocken---------", access_tocken);
        let headers = {
            'content-type': 'application/json',
            'Authorization': `Bearer ${access_tocken}`
        }
        const url = urls.DEVICE_DETAILS(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
        const response = await get(url, headers); // Perform the API call using the constructed URL
        console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
  
        if (response && Object.keys(response).length > 0) {
          console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
          this.setState({ 
            EditDeviceName: response.device_name || "",
            EditDeviceType: response.device_type || "",
            EditIpAddress: response.ip_address || "",
            EditRTSPAddress: response.rtsp_port || "",
            EditProtocol: response.protocol || "",
            EditPortNumber: response.port_number || "",
            EditDeviceUsername: response.device_username || "",
            EditDevicePassword: response.device_password || "",
            client : response.client || "",
            });
  
        } else {
          console.error("No valid data returned from the get-camera API");
          // this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
        }
      } catch (error) {
        console.error("Error fetching cameras from API:", error);
        // this.setState({ cameras: [] }); // Clear the cameras list in case of error
      }
    };

    handleSaveDeviceEditedInfo =  async (selected_device_id) => {
  
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
  
        let data = {
          "device_name": this.state.EditDeviceName,
          "device_type": this.state.EditDeviceType,
          "client" : this.state.client,
          "ip_address": this.state.EditIpAddress,
          "rtsp_port": this.state.EditRTSPAddress,
          "protocol": this.state.EditProtocol,
          "port_number": this.state.EditPortNumber,
          "device_username": this.state.EditDeviceUsername,
          "device_password": this.state.EditDevicePassword    
        }
        console.log("-----JSON DATA -------->",data);
        let post_data = JSON.stringify(data);
        
        try {
          const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
          const response = await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json', // Specify the content type
              'Authorization': `Bearer ${access_tocken}` // Optional: If your API requires an authorization token
            },
            body: post_data,
            
          });
          console.log("reponse in edit device info ------------->", response);
          if (response.ok) {
  
          //   console.log("reponse.ok ------------->", response.ok);
            this.setState({success_device_edit: true});
  
            // Delay before reload to allow user to see the alert
            setTimeout(() => {
              window.location.reload();
          }, 1000); // 3 seconds delay
            } 
          else {
                // const errorMessage =  response.statusText; // Read the error message from response body
          // alert(`Failed to delete user with ID ${selected_device_id}: ${errorMessage}`);
          this.setState({error_device_edit: true});
  
          }
        } catch (error) {
          console.error('Error during delete request:', error);
        }
      
    }

    handleDeviceDelete =  async (selected_device_id) => {      
        try {
          const{selectedSite}= this.state
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          const url = urls.DEVICE_DETAILS(selected_device_id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
          console.log("reponse in delete device url ------------->", url);
          const response = await fetch(url, {
            method: 'DELETE',
            headers: {
              'content-Type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`,
            },
            
          });
          console.log("reponse in delete elevator ------------->", response);
          if (response.ok) {
  
          //   console.log("reponse.ok ------------->", response.ok);
  
            // const data =  response.json(); 
            console.log(`device with id ${selected_device_id} deleted successfully`, response);
            this.openSnackbar("Device deleted successfully!", 'success');
            
            setTimeout(() => {
              this.getDevicesListById(selectedSite)
              }, 2600);
            } 
          else {
                const errorMessage =  response.statusText; // Read the error message from response body
                this.openSnackbar("Error while deleting the device, Try again!", 'error');
                // window.location.reload();
                
                setTimeout(() => {
                  this.getDevicesListById(selectedSite)
                  }, 2600);   
          }
        } catch (error) {
          console.error('Error during delete request:', error);
        }
      
    }

    // getHDDColor = (storage) => {  //Old working function
    //   if (!storage) return "black"; // Default color in case of missing data
    
    //   const [used, total] = storage.split("/").map(value => parseFloat(value));
    //   if (isNaN(used) || isNaN(total) || total === 0) return "black"; // Handle edge cases
    
    //   const usedPercentage = (used / total) * 100;
    
    //   return usedPercentage < 80 ? "green" : "red"; // Green if < 80%, Red if ≥ 80%  totalFreeSpace, totalSpace
    // };

    getHDDColor = (totalFreeSpace, totalSpace) => { //new func to show color based on addition of free space of all hdd
      if (!totalFreeSpace && !totalSpace) return "black"; // Default color in case of missing data
    
      // const [used, total] = storage.split("/").map(value => parseFloat(value));
      if (isNaN(totalFreeSpace) || isNaN(totalSpace) || totalSpace === 0) return "black"; // Handle edge cases
    
      const usedPercentage = (totalFreeSpace / totalSpace) * 100;
    
      return usedPercentage < 80 ? "green" : "red"; // Green if < 80%, Red if ≥ 80%  totalFreeSpace, totalSpace
    };
    

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

    handleSaveGroup = async() => {
      console.log("handleSaveGroup----:");
      const{group_name, parent_group} = this.state
      if (!group_name) {
              this.setState({ warning_site: true });
              return;
          }
    
          const data = JSON.stringify({
            "group_name": group_name,
            "parent_group": parent_group
          });

          // let data = {
            
          // };
          // data = JSON.stringify(data)
  
          console.log("Data to be saved----:", data);
          this.startLoading()
          try{
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
              console.log("--------auth tocken---------", access_tocken);
              let headers = {
                  // 'content-type': 'application/json',
                  'Content-Type': 'application/json',
                  // 'Authorization': `Bearer ${access_tocken}`,
                  // 'x-mock-response-code': '200'
              }
              const response = await post(`https://6adf5c5b-24c4-4985-891f-f2705b01f38c.mock.pstmn.io/addgroup`, data, headers);

              console.log("reposne of const===> ", response);
              // if (response) {
              //         this.setState({ success_site: true });
                  
              //     // Delay for alert visibility before reload
              //     setTimeout(() => {
              //         window.location.reload();
              //     }, 1500);
              // }
              // else{
              //     console.error('Error:');
              //     this.setState({ error_site: true });
              // }
          }
          catch (error) {
              console.error('Error:', error);
              this.setState({ error_site: true});
          }
          this.stopLoading()
    } 

    handleAddGroup = async() => {
      console.log("---handleAddGroup----");
      this.setState({ anchorE3: null, AddGroupToggle: true });
          
    }

    getTaskTitle = (taskId) => {
    const { taskIds } = this.state;
    if (!taskIds) return "Unknown Task";

    // Reverse lookup: Find the key by value
    const taskMap = {
      disk_task: " Disk Info",
      device_info_task: " Device Info",
      chain_task: " Channel Info",
      time_zone:"Timezone Info",

    };

    for (const [key, value] of Object.entries(taskIds)) {
      if (value === taskId) {
        return taskMap[key] || "Unknown Task";
      }
    }

    return "Unknown Task";
    };


  toggleDetails = () => { //state change to show all hdd data onclick of 'i' icon
    this.setState((prevState) => ({
      showDiskDetails: !prevState.showDiskDetails,
    }));
  };


  render() {
    const { devices, currentPage, rowsPerPage, searchInput, selectedSiteInfo,
     selectedSite,  site_list,  user_type } = this.state;

    const {toggleAddSite, sitename,  city, street, zip, state, organisationName, warning_site, success_site, error_site, client_list, toggleAddDevice,
       country, editToggle, edit_sitename, edit_address, edit_organisation_name, success, error, edit_selected_Customers_list,
       edit_city, edit_zip, edit_state, edit_country} = this.state;

    const {loading, deviceName, deviceType, ipAddress, protocol, portNumber, rtsp_port, deviceUsername,
    devicePassword, warning_device, warning1_device, error_device, error1_device, success_device,
    device_type_list, showModal, showTestModal, responseMessage, anchorEl, anchorE2, anchorE3,
    confirmDialog, AddGroupToggle, group_name, parent_group } = this.state

    const { editDeviceToggle , Selected_Device_Id, EditDeviceName, EditDeviceType, EditProtocol, EditPortNumber, EditIpAddress, EditRTSPAddress,
      EditDeviceUsername, EditDevicePassword, success_device_edit, error_device_edit, passwordShown, showDiskDetails  } = this.state

    const open = Boolean(anchorEl);
    const open1 = Boolean(anchorE2);
    const open2 = Boolean(anchorE3);

    // Ensure devices is an array
    const filtered_Devices = (Array.isArray(devices) ? devices : []).filter((device) =>
      device.device_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    );

    // Ensure cameras is an array
    // const filteredCameras = (Array.isArray(cameras) ? cameras : []).filter((camera) =>
    //   camera.camera_name?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    // );

    const filtered_Sites = (Array.isArray(site_list) ? site_list : []).filter((site) =>
      site.sitename?.toLowerCase().includes(searchInput?.toLowerCase() ?? "")
    );


    // Pagination logic
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filtered_Devices.slice(indexOfFirstRow, indexOfLastRow);
    // const currentSites = filtered_Sites.slice(indexOfFirstRow, indexOfLastRow);
    // const currentCamRows = filteredCameras.slice(indexOfFirstRow, indexOfLastRow);

    // Ensure device.hard_disks exists and is an array
    const hardDisks = Array.isArray(filtered_Devices.hard_disks) ? filtered_Devices.hard_disks : [];

    // Calculate total free and total space (ensure hard disks exist)
    const totalFreeSpace = hardDisks.reduce(
      (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0),
      0
    );

    const totalSpace = hardDisks.reduce(
      (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0),
      0
    );

      // console.log(devices,"devices");

    // if (devices && devices[0].hard_disks.length > 0) {
    //   hddStorageList = devices.hard_disks.map((disk)=>{
    //     return disk.free_total_ratio
    //   })
    //   hddStorage = hddStorageList.join(",")
    //   console.log(hddStorage,"hdd");
    // }

    return (
      <div style={{ height: "100vh", overflow: "hidden" }}>
        {/* Navigation Bar */}
        <Navigationbar />
        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
            marginLeft: "93px",
            maxWidth: "100%",
          }}
        >
          {/* Main Content with Flexbox Layout */}
          <Box sx={{ display: "flex", flexGrow: 1 }}>
            {/* Vertical Menu for Sites */}
            <Box
              sx={{
                width: "190px", // Adjust the width of the sidebar
                backgroundColor: "#fff",
                borderRight: "1px solid #ddd",
                padding: "12px",
                overflowY: "none",
                flexShrink: 0, // Prevent sidebar from shrinking
                // marginLeft:'200px',
                height: "95vh",
                // Scrollbar styling
                "&::WebkitScrollbar": {
                  width: "8px", // Adjust scrollbar thickness
                },
                "&::WebkitScrollbarThumb": {
                  backgroundColor: "#aaa", // Color of the scrollbar thumb
                  borderRadius: "4px", // Rounded corners for the thumb
                },
                "&::WebkitScrollbarThumb:hover": {
                  backgroundColor: "#888", // Color when hovered
                },
                scrollbarWidth: "none", // Adjust scrollbar thickness in Firefox
                scrollbarColor: "#aaa #f0f0f0",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ color: "#1058a0", paddingLeft: "8px" }}
                >
                  Sites
                </Typography>
                {/* <div> ------------------under development---temporarily commented for demo.
                  <IconButton onClick={this.handleGroupKebabClick}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorE3}
                    open={open2}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem onClick={this.handleAddGroup}>Add Group</MenuItem>
                    <MenuItem onClick={()=>this.openDialog(() => this.handleDelete(selectedSiteInfo.id))}>Delete</MenuItem>
                  </Menu>
                </div> */}
              </div>
              {/* Filter and Search, site list */}
              <Box display="flex" gap={1} marginBottom={2}>
                <TextField
                  label="Search by Site Name"
                  variant="outlined"
                  value={searchInput}
                  sx={{
                    flexGrow: 1,
                    "& .MuiOutlinedInput-root": {
                      height: "35px", // Adjust the height of the input box
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px", // Resize the label
                      top: "-6px",
                    },
                    "& .MuiInputLabel-shrink": {
                      fontSize: "12px", // Adjust the label size when shrunk
                    },
                  }}
                  onChange={this.handleSearchInputChange}
                />
              </Box>
              <List>
                {filtered_Sites.map((site) => (
                  <React.Fragment key={site.id}>
                    <ListItemButton
                      selected={this.state.selectedSite === site.id}
                      onClick={() => this.handleSiteSelection(site.id, site)}
                      sx={{ borderRadius: "6px" }}
                    >
                      {/* Folder Icon for Sites */}
                      <ListItemIcon sx={{ minWidth: "35px" }}>
                        <FolderIcon style={{ color: "#555" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={site.sitename}
                        sx={{
                          "& .MuiTypography-root": {
                            // fontWeight: 'bold',
                            color: "#333",
                          },
                        }}
                      />
                    </ListItemButton>

                    {/* Submenu for Devices */}
                    {selectedSite === site.id && (
                      <List sx={{ pl: 2 }}>
                        {this.state.devices.map((device) => (
                          <ListItemButton
                            key={device.id}
                            sx={{ borderRadius: "6px", cursor: "default" }}
                          >
                            <img
                              src={DeviceIcon}
                              alt="device-icon"
                              width="25px"
                            />{" "}
                            &ensp;
                            <ListItemText
                              primary={device.device_name}
                              sx={{
                                "& .MuiTypography-root": {
                                  fontWeight: "500",
                                  color: "#444",
                                },
                              }}
                            />
                          </ListItemButton>
                        ))}
                      </List>
                    )}
                  </React.Fragment>
                ))}
              </List>
            </Box>

            {/* Main Content Area */}
            <Box
              // sx={{
              //   flexGrow: 1, // Occupy remaining horizontal space
              //   padding: '6px',
              //   // minWidth: 0, // Prevent content overflow
              //   height:'80vh',
              //   overflowX:'scroll',
              // }}
              style={{
                flexGrow: 1, // Occupy remaining horizontal space
                padding: "6px",
                height: "80vh",
                overflowX: "scroll", //for device table scrolling, parent component should have this css
                "&::WebkitScrollbar": {
                  width: "1px", // Adjust scrollbar thickness
                },
                "&::WebkitScrollbarThumb": {
                  backgroundColor: "#f7f5f5", // Color of the scrollbar thumb
                  borderRadius: "4px", // Rounded corners for the thumb
                },
                "&::WebkitScrollbarThumb:hover": {
                  backgroundColor: "#888", // Color when hovered
                },
                scrollbarWidth: "none", // Adjust scrollbar thickness in Firefox
                scrollbarColor: " #aaa #f7f5f5",
              }}
            >
              <div>
                <Box
                  component={Paper}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "right",
                    backgroundColor: "white",
                    height: "1cm",
                  }}
                >
                  {user_type === "DealerUser" && (
                    <Button
                      id="rowsPerPageButton"
                      onClick={this.NavigateToAddSIte}
                      variant="contained"
                    >
                      {"+ Add Site"}
                    </Button>
                  )}
                </Box>
              </div>
              {selectedSiteInfo ? (
                <>
                  {/* Selected Site Information */}
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      color: "#1058a0",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Site : {selectedSiteInfo.sitename}
                  </Typography>

                  <TableContainer
                    component={Paper}
                    sx={{ marginBottom: "16px", maxWidth: "100%" }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">
                            <Typography fontWeight={550} variant="subtitle2">
                              Site Name
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography fontWeight={550} variant="subtitle2">
                              Location
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography fontWeight={550} variant="subtitle2">
                              Timezone
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography fontWeight={550} variant="subtitle2">
                              Organisation Name
                            </Typography>
                          </TableCell>
                          <TableCell> </TableCell>
                          {/* <TableBody>

                          </TableBody> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">
                            <Typography variant="subtitle2">
                              {selectedSiteInfo?.sitename || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="subtitle2">
                              {selectedSiteInfo?.address || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="subtitle2">
                              {selectedSiteInfo?.timezone || "N/A"}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="subtitle2">
                              {selectedSiteInfo?.organisation_name || "N/A"}
                            </Typography> 
                            {/*<Typography variant="subtitle2">
                                {selectedSiteInfo?.timezone && selectedSiteInfo?.timezone !== "Address not found"
                                    ? this.getCurrentTimeInDeviceTimezone(selectedSiteInfo?.timezone)
                                    : "Fetching Timezone..."}
                            </Typography> */}

                          </TableCell>
                          {user_type === "DealerUser" && (
                            <TableCell align="center">
                              <div>
                                <IconButton onClick={this.handleClick}>
                                  <MoreVertIcon />
                                </IconButton>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={this.handleClose}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                >
                                  <MenuItem onClick={this.handleEdit}>
                                    Edit
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() =>
                                      this.openDialog(() =>
                                        this.handleDelete(selectedSiteInfo.id)
                                      )
                                    }
                                  >
                                    Delete
                                  </MenuItem>
                                </Menu>
                              </div>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* device heading and Add device button */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h7"
                      gutterBottom
                      style={{
                        color: "#1058a0",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Device List
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={SyncIcon}
                        alt="sync-icon"
                        width="50px"
                        onClick={this.deviceSync}
                        title="Sync Devices"
                        style={{ cursor: "pointer" }}
                      />
                      {user_type === "DealerUser" && (
                        <Button
                          id="rowsPerPageButton"
                          onClick={this.NavigateToAddDevice}
                          variant="contained"
                        >
                          {"+ Add Device"}
                        </Button>
                      )}
                    </div>
                  </div>

                  {/* Map devices */}
                  <TableContainer
                    component={Paper}
                    sx={{
                      overflowY: "scroll",
                      // overflowx:'scroll',
                      "&::WebkitScrollbar": {
                        width: "0.2px", // Adjust scrollbar thickness
                      },
                      "&::WebkitScrollbarThumb": {
                        backgroundColor: "rgb(222, 239, 255)", // Color of the scrollbar thumb
                        borderRadius: "1px", // Rounded corners for the thumb
                      },
                      "&::WebkitScrollbarThumb:hover": {
                        backgroundColor: "#888", // Color when hovered
                      },
                      scrollbarWidth: "1px", // Adjust scrollbar thickness in Firefox
                      scrollbarColor: " #f7f5f5",
                    }}
                  >
                    <Table style={{ tableLayout: "auto", width: "100%" }}>
                      <TableHead>
                        <TableRow>
                          {[
                            "Group Name",
                            "Site Name",
                            "HDD Storage (Used/Total)",
                            "System Channel Max",
                            "Active Cameras",
                            "Current Site Time",
                            "Current Device Time",
                            "Health",
                            "Online",
                            "Storage Health",
                            "IP Address",
                            "",
                          ].map((header) => (
                            <TableCell
                              key={header}
                              align="center"
                              // sx={{ whiteSpace: "nowrap", WebkitLineClamp: 2 }}
                            >
                              <Typography
                                variant="subtitle2"
                                fontWeight={550}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {header}

                                {header === "Health" && (
                                  <Tooltip
                                    title={
                                      "Health of device w.r.t its number of camera(s) having recording days issue and/or number of camera(s) in inactive state "
                                    }
                                  >
                                    <InfoOutlinedIcon
                                      fontSize="small"
                                      sx={{ ml: 0.5 }}
                                    />
                                  </Tooltip>
                                )}
                              </Typography>
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentRows.length > 0 ? (
                          currentRows.map((device) => (
                            <React.Fragment key={device.id}>
                              <TableRow>
                                <TableCell
                                  align="center"
                                  onClick={() =>
                                    this.handleAboutDeviceNavigation(
                                      device.id,
                                      device.site_name,
                                      device.device_name
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {/* <IconButton size="small">
                                  {expandedRow === device.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                </IconButton> */}
                                  {device.device_name}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  onClick={() =>
                                    this.handleAboutDeviceNavigation(
                                      device.id,
                                      device.site_name,
                                      device.device_name
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  {device.site_name || "N/A"}
                                </TableCell>
                                {/* <TableCell align="center">
                                  {device && device.hard_disks.length > 0 ? (
                                    <div>
                                      {device.hard_disks.map((disk) => {
                                        return (
                                          <p
                                            style={{
                                              color: this.getHDDColor(
                                                disk.free_total_ratio
                                              ),
                                            }}
                                          >
                                            {disk.free_total_ratio}
                                          </p>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    device.hdd_storage
                                  )}
                                </TableCell> */}
                                <TableCell align="center" >
                                  {device.hard_disks.length > 1 ? (
                                    <div >
                                      {/* Calculate total storage dynamically */}
                                      {(() => {
                                        const totalFreeSpace = device.hard_disks.reduce(
                                          (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0),
                                          0
                                        );

                                        const totalSpace = device.hard_disks.reduce(
                                          (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0),
                                          0
                                        );

                                        return (
                                          <>
                                            <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                              {/* <strong>Total: </strong> */}
                                              <span style={{ color: this.getHDDColor(totalFreeSpace, totalSpace) }}>
                                                {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                              </span>
                                              <IconButton onClick={this.toggleDetails} size="small">
                                                <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.1 }} />
                                              </IconButton>
                                            </div>
                                            {showDiskDetails && (
                                              <div>
                                                {device.hard_disks.map((disk) => (
                                                  <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                    hdd{disk.disk_id}:{disk.free_space_gb}/
                                                    {disk.total_space_gb}
                                                  </p>
                                                ))}
                                              </div>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                  ) : (
                                    <p>{device.hdd_storage || "No Storage Info"}</p>
                                  )}
                                </TableCell>

                                <TableCell align="center">
                                  {device.chl_max_count}
                                </TableCell>
                                <TableCell align="center">
                                  {device.total_cameras}
                                </TableCell>
                                <TableCell align="center">
                                <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                  <Box
                                    color={
                                      device.timezone_match ? "green" : "red"
                                    }
                                  >
                                    {this.getCurrentTimeInDeviceTimezone(
                                      device.site_timezone
                                    )}{" "}
                                  </Box>
                                  {device.site_timezone && (
                                  <Tooltip
                                    title={
                                      `Timezone: ${device.site_timezone}`
                                    }
                                  >
                                    <InfoOutlinedIcon
                                      fontSize="small"
                                      sx={{ ml: 0.5 }}
                                    />
                                  </Tooltip>
                                )}
                                </div>
                                </TableCell>
                                <TableCell align="center">
                                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                  <Box
                                    color={
                                      device.timezone_match ? "green" : "red"
                                    }
                                  >
                                    {device.current_time}
                                    
                                   </Box>
                                  {device.current_time && (
                                    <Tooltip
                                      title={
                                        `Timezone: ${device.current_time}`
                                      }
                                    >
                                      <InfoOutlinedIcon
                                        fontSize="small"
                                        sx={{ ml: 0.5 }}
                                      />
                                    </Tooltip>
                                  )}
                                  </div>
                                </TableCell>
                                <TableCell align="center">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    {device.health_issues_count}
                                    {device.health_issues_count <= 0 ? (
                                      <CheckCircleIcon color="success" />
                                    ) : (
                                      <CancelIcon color="error" />
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell align="center">
                                  <Tooltip
                                    title={
                                      device.status === "active"
                                        ? "Device is active"
                                        : "Device is inactive"
                                    }
                                  >
                                    {device.status === "active" ? (
                                      <CheckCircleIcon color="success" />
                                    ) : (
                                      <CancelIcon color="error" />
                                    )}
                                  </Tooltip>
                                </TableCell>
                                {/* <TableCell align="center">
                                {device && device.hard_disks.length > 0 ? (
                                      <div>
                                        {device.hard_disks.map((disk) => {
                                          return (
                                            <Tooltip
                                              title={
                                                disk.status === "RW" || disk.status === "read/write"
                                                  ? "Storage is healthy"
                                                  : "Storage has issues"
                                              }
                                            >
                                              {disk.status === "RW" || disk.status === "read/write" ? (
                                                <div>

                                                  <CheckCircleIcon color="success" />
                                                </div>
                                              ) : (
                                                <div>

                                                  <CancelIcon color="error" />
                                                </div>
                                              )}
                                            </Tooltip>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <Tooltip
                                        title={
                                          device.storage_health === "Ok"
                                            ? "Storage is healthy"
                                            : "Storage has issues"
                                        }
                                      >
                                        {device.storage_health === "Ok" ? (
                                          <CheckCircleIcon color="success" />
                                        ) : (
                                          <CancelIcon color="error" />
                                        )}
                                      </Tooltip>
                                    )}
                                </TableCell> */}
                                <TableCell align="center">
                                  {device && device.hard_disks.length > 0 ? (() => {
                                    // Check if all hard disks have status "RW"
                                    const allHealthy = device.hard_disks.every(disk => disk.status === "RW" || disk.status === "read/write");

                                    return (
                                          <div>
                                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                              <Tooltip title={allHealthy ? "All disks are healthy" : "One or more disks have issues"}>
                                                {allHealthy ? (
                                                  <CheckCircleIcon color="success" />
                                                ) : (
                                                  <CancelIcon color="error" />
                                                )}
                                              </Tooltip>
                                              {/* Info icon to toggle hard disk details */}
                                              <IconButton onClick={this.toggleDetails} size="small">
                                                <InfoOutlinedIcon fontSize="small" />
                                              </IconButton>
                                            </div>
  
                                            {/* Show details of each hard disk when toggled */}
                                            {this.state.showDiskDetails && (
                                              <div style={{ marginTop: "5px" }}>
                                                {device.hard_disks.map((disk) => (
                                                  <div key={disk.disk_id} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    <span>hdd{disk.disk_id}:</span>
                                                    <Tooltip title={disk.status === "RW" || disk.status === "read/write" ? "Healthy" : "Issue detected"}>
                                                      {disk.status === "RW" || disk.status === "read/write" ? (
                                                        <CheckCircleIcon color="success" />
                                                      ) : (
                                                        <CancelIcon color="error" />
                                                      )}
                                                    </Tooltip>
                                                  </div>
                                                ))}
                                              </div>
                                            )}
                                          </div>
                                        );
                                  })() : (
                                    <Tooltip title={device.storage_health === "Ok" ? "Storage is healthy" : "Storage has issues"}>
                                      {device.storage_health === "Ok" ? (
                                        <CheckCircleIcon color="success" />
                                      ) : (
                                        <CancelIcon color="error" />
                                      )}
                                    </Tooltip>
                                  )}
                                </TableCell>

                                <TableCell align="center">
                                  <a
                                    component="a"
                                    href={`${device.protocol}://${device.ip_address}:${device.port_number}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={LinkIcon}
                                      alt="ip-globe"
                                      width="26px"
                                      title="Click here to go to the address"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </a>
                                  {/* <LinkIcon /> */}
                                  {/* </IconButton> */}
                                </TableCell>
                                <TableCell align="center">
                                  <div>
                                    <IconButton
                                      onClick={this.handleDeviceKebabClick}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                      anchorEl={anchorE2}
                                      open={open1}
                                      onClose={this.handleClose}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "right",
                                      }}
                                      transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                      }}
                                    >
                                      <MenuItem
                                        onClick={() =>
                                          this.TestConnection(device)
                                        }
                                      >
                                        Test Connection
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() =>
                                          this.LoadSelectedDeviceInfo(device.id)
                                        }
                                      >
                                        Edit
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() =>
                                          this.openDialog(() =>
                                            this.handleDeviceDelete(device.id)
                                          )
                                        }
                                      >
                                        Delete
                                      </MenuItem>
                                    </Menu>
                                  </div>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))
                        ) : loading ? (
                          <TableRow>
                            <TableCell
                              colSpan={10}
                              align="center"
                              style={{ color: "orange" }}
                            >
                              Loading...
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={10}
                              align="center"
                              style={{ color: "orange" }}
                            >
                              No device is configured for this site. Please add
                              a device.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Typography
                  variant="h6"
                  color="textSecondary"
                  align="center"
                  sx={{ marginTop: "20%" }}
                >
                  Please select a site to view devices.
                </Typography>
              )}
            </Box>
          </Box>

          <div
            style={{
              marginTop: "2px",
              display: "flex",
              justifyContent: "center",
              marginBottom: "3cm",
              alignItems: "center",
            }}
          >
            {/* <Button
                  id="rowsPerPageButton"
                  onClick={() => this.handleChangePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  variant="contained"
                  sx={{
                    margin: '0 10px',
                    borderRadius: '8px',
                    padding: '8px 10px',
                    fontSize: '14px',
                    minWidth: '90px',
                    background: 'linear-gradient(145deg, #001f54, #003366)',  // Primary color gradient
                    boxShadow: 2,
                    '&:hover': {
                      background: 'linear-gradient(145deg, #003366, #001f54)',  // Inverted gradient for hover effect
                    },
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  }}
                >
                  {"< Prev"}
                </Button>

                <span style={{ fontSize: 'small', color: '#555' }}>
                  {`Page ${currentPage} / ${Math.ceil(filteredDevices.length / rowsPerPage)}`}
                </span>&emsp;

            <Button
              id="rowsPerPageButton"
              onClick={() => this.handleChangePage(currentPage + 1)}
              disabled={currentPage === Math.ceil(filteredDevices.length / rowsPerPage)}
              variant="contained"
              sx={{
                margin: '0 10px',
                borderRadius: '8px',
                padding: '8px 10px',
                fontSize: '14px',
                minWidth: '90px',
                background: 'linear-gradient(145deg, #001f54,rgb(3, 82, 162))',  // Primary color gradient
                boxShadow: 2,
                '&:hover': {
                  background: 'linear-gradient(145deg, #003366,rgb(4, 48, 123))',  // Inverted gradient for hover effect
                },
                cursor: currentPage === Math.ceil(filteredDevices.length / rowsPerPage) ? 'not-allowed' : 'pointer',
              }}
            >
              {"Next >"}
            </Button> */}

            <Snackbar
              open={this.state.open_snackbar}
              autoHideDuration={5000}
              onClose={() => this.setState({ open_snackbar: false })}
              anchorOrigin={{ vertical: "center", horizontal: "center" }}
            >
              <Alert
                onClose={() => this.setState({ open_snackbar: false })}
                variant="filled"
                elevation={6}
                severity={this.state.alert_type}
              >
                {this.state.snackbar_msg}
              </Alert>
            </Snackbar>
          </div>
          {toggleAddSite && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                zIndex: 999,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align vertically
              }}
            >
              <div className="Slide-left-edit-form">
                {/* Close icon */}
                <button
                  onClick={this.closePopup}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
                <div>
                  <div className="form-section" style={{ padding: "12px" }}>
                    <h3
                      style={{
                        color: "#fff",
                        textAlign: "center",
                        backgroundColor: "#003366",
                        height: "1cm",
                        alignContent: "center",
                      }}
                    >
                      Add New Site
                    </h3>
                    {warning_site && (
                      <Alert severity="warning">
                        Please fill all the required fields.
                      </Alert>
                    )}
                    {error_site && (
                      <Alert severity="error">
                        Server Error! Could not save site information.
                      </Alert>
                    )}
                    {success_site && (
                      <Alert
                        icon={<CheckIcon fontSize="inherit" />}
                        severity="success"
                      >
                        Site information saved successfully.
                      </Alert>
                    )}

                    <input
                      type="text"
                      name="sitename"
                      placeholder="Site Name *"
                      value={sitename}
                      onChange={this.handleInputChange}
                      style={{
                        width: "98%",
                        marginBottom: "10px",
                        padding: "8px",
                      }}
                    />
                    <input
                      type="text"
                      name="organisationName"
                      placeholder="Organisation Name *"
                      value={organisationName}
                      onChange={this.handleInputChange}
                      style={{
                        width: "98%",
                        marginBottom: "10px",
                        padding: "8px",
                      }}
                    />
                    <input
                      type="text"
                      name="street"
                      placeholder="Address *"
                      value={street}
                      onChange={this.handleInputChange}
                      style={{
                        width: "34%",
                        marginBottom: "10px",
                        padding: "8px",
                      }}
                    />
                    <input
                      type="text"
                      name="city"
                      placeholder="City *"
                      value={city}
                      onChange={this.handleInputChange}
                      style={{
                        width: "34%",
                        marginBottom: "10px",
                        padding: "8px",
                        marginLeft: "4px",
                      }}
                    />
                    <input
                      type="text"
                      name="zip"
                      placeholder="Zip *"
                      value={zip}
                      onChange={this.handleInputChange}
                      // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                      style={{
                        width: "25%",
                        marginBottom: "11px",
                        padding: "8px",
                        fontSize: "13px",
                        marginLeft: "3px",
                      }}
                    />
                    <input
                      type="text"
                      name="state"
                      placeholder="State *"
                      value={state}
                      onChange={this.handleInputChange}
                      style={{
                        width: "46.5%",
                        marginBottom: "10px",
                        padding: "8px",
                      }}
                    />

                    <input
                      type="text"
                      name="country"
                      placeholder="Country *"
                      value={country}
                      onChange={this.handleInputChange}
                      // style={{ width: '25%', marginBottom: '10px', padding: '8px', marginLeft:'3px' }}
                      style={{
                        width: "49%",
                        marginBottom: "11px",
                        padding: "8px",
                        marginLeft: "3px",
                        fontSize: "13px",
                      }}
                    />

                    <label style={{ fontSize: "15px" }}>
                      {" "}
                      Select Customer/s :
                    </label>
                    <select
                      name="customers"
                      multiple
                      onChange={this.handleSelectionChange}
                      style={{
                        width: "100%",
                        marginBottom: "15px",
                        marginTop: "5px",
                        padding: "8px",
                        fontSize: "13px",
                      }}
                    >
                      {client_list.map((customer) => (
                        <option key={customer.user_id} value={customer.user_id}>
                          {customer.first_name} - {customer.email}
                        </option>
                      ))}
                    </select>

                    {/* <button
                              type="button"
                              onClick={this.handleSiteSave}
                              style={{ padding: '10px 20px', fontSize: '16px' }}
                          >
                              <b>Save</b>
                          </button> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "right",
                        gap: "5px",
                        marginTop: "15px",
                      }}
                    >
                      <Button
                        type="button"
                        onClick={this.handleSiteSave}
                        style={{
                          width: "3cm",
                          height: "0.9cm",
                          background:
                            "linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))", // Primary color gradient
                          boxShadow: 2,
                          "&:hover": {
                            background:
                              "linear-gradient(145deg, #003366,rgb(4, 99, 123))", // Inverted gradient for hover effect
                          },
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        Add Site
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {editToggle && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                zIndex: 999,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align vertically
              }}
            >
              <div className="Slide-site-edit-form">
                {/* Close icon */}
                <button
                  onClick={this.closeEditPopup}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>

                <div className="form-section">
                  <h3
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      backgroundColor: "#003366",
                      height: "1cm",
                      alignContent: "center",
                    }}
                  >
                    Edit Site Info
                  </h3>

                  {error ? (
                    <Alert severity="error">
                      Server Error! Site Info was not updated!
                    </Alert>
                  ) : success ? (
                    <Alert
                      icon={<CheckIcon fontSize="inherit" />}
                      severity="success"
                    >
                      "All set! The site info was updated successfully."
                    </Alert>
                  ) : null}

                  <div className="form-group-device-edit">
                    <label htmlFor="sitename">
                      Site Name <span style={{ color: "red" }}> </span>: &nbsp;
                    </label>
                    <input
                      type="text"
                      name="edit_sitename"
                      value={edit_sitename || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="address">Address: &nbsp;</label>
                    <input
                      type="text"
                      name="edit_address"
                      value={edit_address || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="city">City: &nbsp;</label>
                    <input
                      type="text"
                      name="edit_city"
                      value={edit_city || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="zip">Zip: &nbsp;</label>
                    <input
                      type="text"
                      name="edit_zip"
                      value={edit_zip || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="state">State: &nbsp;</label>
                    <input
                      type="text"
                      name="edit_state"
                      value={edit_state || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="country">Country: &nbsp;</label>
                    <input
                      type="text"
                      name="edit_country"
                      value={edit_country || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="organisation_name">
                      Organisation Name: &nbsp;
                    </label>
                    <input
                      type="text"
                      name="edit_organisation_name"
                      value={edit_organisation_name || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>

                  <div className="form-group-device-edit">
                    <label htmlFor="customers">
                      Associated Customers: &nbsp;
                    </label>
                    <select
                      name="edit_selected_Customers_list"
                      multiple
                      onChange={this.handleSelectionChange}
                      style={{
                        width: "365px",
                        height: "2.2cm",
                        color: "black",
                      }}
                      value={edit_selected_Customers_list.map(
                        (customer) => customer.user_id
                      )} // Set the selected customers
                    >
                      {client_list.map((customer) => (
                        <option key={customer.user_id} value={customer.user_id}>
                          {customer.username} - {customer.email}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      gap: "5px",
                      marginTop: "15px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={this.handleEditSave}
                      style={{
                        width: "0.8cm",
                        height: "0.7cm",
                        background:
                          "linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))", // Primary color gradient
                        boxShadow: 2,
                        "&:hover": {
                          background:
                            "linear-gradient(145deg, #003366,rgb(4, 99, 123))", // Inverted gradient for hover effect
                        },
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {toggleAddDevice && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                zIndex: 999,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align vertically
              }}
            >
              <div className="Slide-device-Add-form">
                {/* Close icon */}
                <button
                  onClick={this.closePopup}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
                <div className="form-section">
                  <h3
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      backgroundColor: "#003366",
                      height: "1cm",
                      alignContent: "center",
                    }}
                  >
                    Add New Device
                  </h3>

                  {warning_device ? (
                    <Alert severity="warning">
                      Please fill all the required fields.
                    </Alert>
                  ) : error_device ? (
                    <Alert severity="error">
                      Server Error! New device was not added!
                    </Alert>
                  ) : error1_device ? (
                    <Alert severity="error">{responseMessage}</Alert>
                  ) : warning1_device ? (
                    <Alert severity="warning">
                      "Device added Successfully, but it's not reachable!"
                      {/* {responseMessage} */}
                    </Alert>
                  ) : success_device ? (
                    <Alert
                      icon={<CheckIcon fontSize="inherit" />}
                      severity="success"
                    >
                      "All set! The device registration was successful."
                    </Alert>
                  ) : null}
                  <input
                    type="text"
                    name="deviceName"
                    placeholder="Group Name *"
                    value={deviceName}
                    onChange={this.handleInputChange}
                    style={{ width: "98%" }}
                  />
                  <select
                    name="deviceType"
                    title="If you cannot find a device type, contact the admin"
                    value={deviceType}
                    onChange={this.handleInputChange}
                    style={{ padding: "8px", fontSize: "13px" }}
                  >
                    <option value="" disabled>
                      Select Device Type *
                    </option>
                    {device_type_list.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.type_name}
                      </option>
                    ))}
                  </select>
                  <select
                    name="selectedSite"
                    // value={client}
                    value={selectedSite} // Set value to selectedSite
                    onChange={this.handleInputChange}
                    style={{ padding: "8px", fontSize: "13px", color: "black" }}
                  >
                    <option value="" disabled>
                      Select Site *
                    </option>
                    {site_list && Array.isArray(site_list) ? (
                      site_list.map((client) => (
                        <option key={client.id} value={client.id}>
                          {client.sitename}
                        </option>
                      ))
                    ) : (
                      <option disabled>No sites available</option>
                    )}
                  </select>
                  <div>
                    <input
                      type="text"
                      name="ipAddress"
                      placeholder="IP Address *"
                      value={ipAddress}
                      onChange={this.handleInputChange}
                      style={{ width: "98%" }}
                    />
                    <input
                      type="text"
                      name="rtsp_port"
                      placeholder="RTSP Port Number*"
                      value={rtsp_port}
                      onChange={this.handleInputChange}
                      style={{ width: "98%" }}
                    />
                  </div>
                  <select
                    name="protocol"
                    value={protocol}
                    onChange={this.handleInputChange}
                    style={{ padding: "8px", fontSize: "13px" }}
                  >
                    <option value="" disabled>
                      Select Server Protocol *
                    </option>
                    <option value="HTTP://">HTTP:// Protocol</option>
                    <option value="HTTPS://">HTTPS:// Protocol</option>
                  </select>
                  <input
                    type="text"
                    name="portNumber"
                    placeholder="Server Port Number *"
                    value={portNumber}
                    onChange={this.handleInputChange}
                    style={{ width: "98%" }}
                  />
                  <input
                    type="text"
                    name="deviceUsername"
                    placeholder="Device Username *"
                    value={deviceUsername}
                    onChange={this.handleInputChange}
                    style={{ width: "98%" }}
                  />
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "98%",
                    }}
                  >
                    <input
                      type={passwordShown ? "text" : "password"}
                      name="devicePassword"
                      placeholder="Device Password *"
                      value={devicePassword}
                      onChange={this.handleInputChange}
                      style={{ width: "100%" }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "1px",
                        top: "48%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                      <img
                        onClick={this.togglePasswordVisiblity}
                        src={passwordEye}
                        alt="password-eye"
                        width="25"
                        height="25"
                      />
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      gap: "5px",
                      marginTop: "15px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={this.handleSubmit}
                      style={{
                        width: "3.5cm",
                        height: "0.7cm",
                        background:
                          "linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))", // Primary color gradient
                        boxShadow: 2,
                        "&:hover": {
                          background:
                            "linear-gradient(145deg, #003366,rgb(4, 99, 123))", // Inverted gradient for hover effect
                        },
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      Add Device
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {editDeviceToggle && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                zIndex: 999,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align vertically
              }}
            >
              <div className="Slide-device-Add-form">
                {/* Close icon */}
                <button
                  onClick={this.closePopup}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
                <div className="form-section">
                  {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                  <h3
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      backgroundColor: "#003366",
                      height: "1cm",
                      alignContent: "center",
                    }}
                  >
                    Edit Device Info
                  </h3>

                  {/* {error && <div className="alert alert-danger" style={{color :'#d9645c', fontSize:'small'}}>{error}</div>}<br/>
                        {success && <div className="alert alert-success">{success}</div>} */}
                  {error_device_edit ? (
                    <Alert severity="error">
                      Server Error! Device Info was not edited!
                    </Alert>
                  ) : success_device_edit ? (
                    <Alert
                      icon={<CheckIcon fontSize="inherit" />}
                      severity="success"
                    >
                      "Device Info edited successfully."
                    </Alert>
                  ) : null}
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      Device name <span style={{ color: "red" }}>*</span>:
                      &nbsp;
                    </label>
                    <input
                      type="text"
                      name="EditDeviceName"
                      value={EditDeviceName || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      Device Type <span style={{ color: "red" }}>*</span>:
                      &nbsp;
                    </label>
                    <select
                      name="EditDeviceType"
                      placeholder="Device Type"
                      value={EditDeviceType || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "360px", height: "0.9cm" }}
                    >
                      <option value="" disabled>
                        Select Device Type
                      </option>
                      {(device_type_list || []).map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.type_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      IP Address <span style={{ color: "red" }}>*</span>: &nbsp;
                    </label>
                    <input
                      type="text"
                      name="EditIpAddress"
                      placeholder="IP Address"
                      value={EditIpAddress || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      RTSP <span style={{ color: "red" }}>*</span>: &nbsp;
                    </label>
                    <input
                      type="text"
                      name="EditRTSPAddress"
                      placeholder="RTSP "
                      value={EditRTSPAddress || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      Protocol <span style={{ color: "red" }}>*</span>: &nbsp;
                    </label>
                    <select
                      name="EditProtocol"
                      value={EditProtocol || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "360px", height: "0.9cm" }}
                    >
                      <option value="" disabled>
                        Select Server Protocol
                      </option>
                      <option value="HTTP://">HTTP://</option>
                      <option value="HTTPS://">HTTPS://</option>
                      <option value="RTSP://">RTSP://</option>
                    </select>
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      Server Port Number<span style={{ color: "red" }}>*</span>:
                      &nbsp;
                    </label>
                    <input
                      type="text"
                      name="EditPortNumber"
                      value={EditPortNumber || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name">
                      Device Username<span style={{ color: "red" }}>*</span>:
                      &nbsp;
                    </label>
                    <input
                      type="text"
                      name="EditDeviceUsername"
                      value={EditDeviceUsername || ""}
                      onChange={this.handleInputChange}
                      style={{ width: "350px", height: "0.7cm" }}
                    />
                  </div>
                  <div className="form-group-device-edit">
                    <label htmlFor="user_name" style={{ marginLeft: "-2px" }}>
                      Device Password<span style={{ color: "red" }}>*</span>:
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "350px",
                      }}
                    >
                      <input
                        type={passwordShown ? "text" : "password"}
                        name="EditDevicePassword"
                        value={EditDevicePassword || ""}
                        onChange={this.handleInputChange}
                        style={{ width: "97%", height: "0.7cm" }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "0px",
                          top: "48%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                      >
                        {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                        <img
                          onClick={this.togglePasswordVisiblity}
                          src={passwordEye}
                          alt="password-eye"
                          width="25"
                          height="25"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      gap: "5px",
                      marginTop: "15px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={() =>
                        this.handleSaveDeviceEditedInfo(Selected_Device_Id)
                      }
                      style={{
                        width: "3.5cm",
                        height: "0.7cm",
                        background:
                          "linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))", // Primary color gradient
                        boxShadow: 2,
                        "&:hover": {
                          background:
                            "linear-gradient(145deg, #003366,rgb(4, 99, 123))", // Inverted gradient for hover effect
                        },
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      {" "}
                      Save Info{" "}
                    </Button>
                    <Button
                      type="button"
                      onClick={this.closePopup}
                      style={{
                        width: "0.8cm",
                        height: "0.7cm",
                        backgroundColor: "#e02e2e",
                        color: "white",
                      }}
                    >
                      {" "}
                      Cancel{" "}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {AddGroupToggle && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.8)", // Dim effect
                zIndex: 999,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center", // Align vertically
              }}
            >
              <div className="Slide-device-Add-form">
                <button
                  onClick={this.closePopup}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  ✖
                </button>
                <div className="form-section">
                  {/* <h3 style={{color:'#001668', textAlign:'center', backgroundColor:'#dbeffd', height:'1cm', alignContent:'center'}}>Edit Device Info</h3> */}
                  <h3
                    style={{
                      color: "#fff",
                      textAlign: "center",
                      backgroundColor: "#003366",
                      height: "1cm",
                      alignContent: "center",
                    }}
                  >
                    Add Group
                  </h3>
                  <input
                    type="text"
                    name="group_name"
                    placeholder="Group Name *"
                    value={group_name}
                    onChange={this.handleInputChange}
                    style={{ width: "98%" }}
                  />
                  <select
                    name="parent_group"
                    // title="If you cannot find a device type, contact the admin"
                    value={parent_group}
                    onChange={this.handleInputChange}
                    style={{ padding: "8px", fontSize: "13px" }}
                  >
                    <option value="" disabled>
                      Select parent group
                    </option>
                    <option value="mi_site1">mi_site1</option>
                    <option value="Global Alarm">Global Alarm</option>
                    <option value="Savaya Hazel Park">Savaya Hazel Park</option>
                    {/* {device_type_list.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.type_name}
                                </option>
                            ))} */}
                  </select>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      gap: "5px",
                      marginTop: "15px",
                    }}
                  >
                    <Button
                      type="button"
                      onClick={this.handleSaveGroup}
                      style={{
                        width: "3.5cm",
                        height: "0.7cm",
                        background:
                          "linear-gradient(145deg,rgb(4, 99, 123),rgb(13, 160, 186))", // Primary color gradient
                        boxShadow: 2,
                        "&:hover": {
                          background:
                            "linear-gradient(145deg, #003366,rgb(4, 99, 123))", // Inverted gradient for hover effect
                        },
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      {" "}
                      Add Group{" "}
                    </Button>
                    <Button
                      type="button"
                      onClick={this.closePopup}
                      style={{
                        width: "0.8cm",
                        height: "0.7cm",
                        backgroundColor: "#e02e2e",
                        color: "white",
                      }}
                    >
                      {" "}
                      Cancel{" "}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showModal && (
            <div className="modal-device-add">
              <div className="modal-content">
                <div style={{backgroundColor:'#003366', color:'#fff', height:'1.5cm', width:'100%'}}>
                <h3 style={{display:'flext',textAlign:'center', justifyContent:'center', width:'100%'}}>Test Camera Connection Logs</h3>
              
                  <button className="close-button" onClick={this.handleCloseModal}>
                      &times;
                  </button>
                </div>
                <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                    {this.state.open_progress_bar1 ? (
                    <div style={{backgroundColor:'#f4f4f4',  height:'3.5cm', width:'100%', padding:'15px'}}>
                      <h3>Camera connection test in progress</h3>
                      <h4>This may take a few minutes, depending on the speed of the internet connection to your devices</h4>
                    </div>
                    ):(
                      <div style={{backgroundColor:'#f4f4f4',  height:'2.5cm', width:'100%', padding:'15px'}}>
                      <h3 style={{color:"green"}}>Camera connection test is completed!</h3>
                    </div>
                    )
                    }
                    {this.state.taskQueue.length > 0 ? (
                      <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                        {this.state.currentTaskIndex < this.state.taskQueue.length && (
                          <li style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                            
                            <pre>{this.state.taskStatus[this.state.currentTaskIndex]}</pre>
                          </li>
                        )}

                    {this.state.open_progress_bar1 && this.state.currentTaskIndex < this.state.taskStatus.length &&
                      this.state.taskStatus[this.state.currentTaskIndex] !== "✅ Task completed!" && (
                        <Box style={{ zIndex: "1610" }}>
                          <LinearProgress />
                        </Box>
                      )}
                  </ul>
                ) : (
                  <p>No tasks started yet.</p>
                )}
                </div>
                {Object.entries(this.state.taskResults).map(([taskId, result]) => (
                    <Box key={taskId} sx={{ marginBottom: 2 }}>
                        <Typography variant="h6">Task ID: {taskId}</Typography>
                        <Typography variant="body1">Status: {result.status}</Typography>
                        
                        {result.responseMessage && (
                            <Typography variant="body2" color="textSecondary">
                                Message: {result.responseMessage}
                            </Typography>
                        )}
        
                        {/* Example: Displaying Disk Details */}
                        {result.disk_details && result.disk_details.length > 0 && (
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Disk ID</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Free Space (GB)</TableCell>
                                            <TableCell>Total Space (GB)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {result.disk_details.map((disk) => (
                                            <TableRow key={disk.disk_id}>
                                                <TableCell>{disk.disk_id}</TableCell>
                                                <TableCell>{disk.disk_status}</TableCell>
                                                <TableCell>{disk.free_space_gb}</TableCell>
                                                <TableCell>{disk.total_space_gb}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
        
                        {/* Example: Displaying Device Info */}
                        {result.device_info && (
                            <Box sx={{ marginTop: 2 }}>
                                <Typography variant="body2"><strong>Device Model:</strong> {result.device_info.model}</Typography>
                                <Typography variant="body2"><strong>Serial Number:</strong> {result.device_info.serial_number}</Typography>
                                <Typography variant="body2"><strong>Firmware Version:</strong> {result.device_info.firmware_version}</Typography>
                            </Box>
                        )}
                        {/* Display Channel List */}
                        {result.channel_list && result.channel_list.length > 0 && (
                            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Channel ID</TableCell>
                                            <TableCell>Channel Name</TableCell>
                                            <TableCell>Main Stream Bit Rate</TableCell>
                                            <TableCell>Main Stream Resolution</TableCell>
                                            <TableCell>Recording Days</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {result.channel_list.map((channel) => (
                                            <TableRow key={channel.channel_id}>
                                                <TableCell>{channel.channel_id}</TableCell>
                                                <TableCell>{channel.channel_name}</TableCell>
                                                <TableCell>{channel.main_stream_bit_rate}</TableCell>
                                                <TableCell>{channel.main_stream_resolution}</TableCell>
                                                <TableCell>{channel.recording_days}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                ))}
              </div>
            </div>
          )}

          {showTestModal && (
            <div className="modal-device-add">
            <div className="modal-content">
              <div style={{backgroundColor:'#003366', color:'#fff', height:'1.5cm', width:'100%'}}>
                <button className="close-button" onClick={this.handleCloseModal}>
                      &times;
                  </button><br/>
                <h3 style={{display:'flext',textAlign:'center', justifyContent:'center', width:'100%'}}>Test Camera Connection Logs</h3>

              </div>
              <div style={{ marginTop: "20px", textAlign: "left", width:"100%" }}>
                  {this.state.open_progress_bar1 ? (
                  <div style={{backgroundColor:'#f4f4f4',  height:'3.5cm', width:'100%', padding:'15px'}}>
                    <h3>Camera connection test in progress</h3>
                    <h4>This may take a few minutes, depending on the speed of the internet connection to your devices</h4>
                  </div>
                  ):(
                    <div style={{backgroundColor:'#f4f4f4',  height:'2.5cm', width:'100%', padding:'15px'}}>
                    <h3 style={{color:"green"}}>Camera connection test is completed!</h3>
                  </div>
                  )
                  }
                  {this.state.taskQueue.length > 0 ? (
                    <ul style={{ paddingLeft: "20px", listStyleType: "none" }}>
                      {this.state.currentTaskIndex < this.state.taskQueue.length && (
                        <li style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                          
                          <pre>{this.state.taskStatus[this.state.currentTaskIndex]}</pre>
                        </li>
                      )}

                  {this.state.open_progress_bar1 && this.state.currentTaskIndex < this.state.taskStatus.length &&
                    this.state.taskStatus[this.state.currentTaskIndex] !== "✅ Task completed!" && (
                      <Box style={{ zIndex: "1610" }}>
                        <LinearProgress />
                      </Box>
                    )}
                </ul>
              ) : (
                <p>No tasks started yet.</p>
              )}
              </div>
              {Object.entries(this.state.taskResults).map(([taskId, result]) => (
                  <Box key={taskId} sx={{ marginBottom: 2 }}>
                      {/* <Typography variant="h6">Task ID: {taskId}</Typography>
                      <Typography variant="body1">Status: {result.status}</Typography> */}
                      
                      {/* {result.responseMessage && (
                          <Typography variant="body2" color="textSecondary">
                              Message: {result.responseMessage}
                          </Typography>
                      )} */}
      
                      {/* Example: Displaying Disk Details */}
                      {result.disk_details && result.disk_details.length > 0 && (
                        <>
                        <Typography variant="body2" color="textSecondary">
                            Disk Information
                        </Typography>
                          <TableContainer component={Paper}>
                              <Table>
                                  <TableHead>
                                      <TableRow>
                                          <TableCell>Disk ID</TableCell>
                                          <TableCell>Status</TableCell>
                                          <TableCell>Free Space (GB)</TableCell>
                                          <TableCell>Total Space (GB)</TableCell>
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {result.disk_details.map((disk) => (
                                          <TableRow key={disk.disk_id}>
                                              <TableCell>{disk.disk_id}</TableCell>
                                              <TableCell>{disk.disk_status}</TableCell>
                                              <TableCell>{disk.free_space_gb}</TableCell>
                                              <TableCell>{disk.total_space_gb}</TableCell>
                                          </TableRow>
                                      ))}
                                  </TableBody>
                              </Table>
                          </TableContainer>
                        </>
                      )}
      
                      {/* Example: Displaying Device Info */}
                      {result.device_info && (
                        <>
                          <Typography variant="body2" color="textSecondary">
                              Device Information
                          </Typography>
                          <Box sx={{ marginTop: 2 }}>
                              <Typography variant="body2"><strong>Device Name:</strong> {result.device_info.device_name}</Typography>
                              <Typography variant="body2"><strong>Device Type:</strong> {result.device_info.device_type}</Typography>
                              <Typography variant="body2"><strong>Device Model:</strong> {result.device_info.model}</Typography>
                              <Typography variant="body2"><strong>Serial Number:</strong> {result.device_info.serial_number}</Typography>
                              <Typography variant="body2"><strong>Firmware Version:</strong> {result.device_info.firmware_version}</Typography>
                              <Typography variant="body2"><strong>Firmware Version:</strong> {result.device_info.firmware_version}</Typography>
                          </Box>
                        </>
                      )}
                      {result.data && (
                        <>
                            <Typography variant="body2" color="textSecondary">
                                Timezone Information
                            </Typography>
                            <Box sx={{ marginTop: 2 }}>
                                <Typography variant="body2"><strong>Current Device Time:</strong> {result.data.current_time}</Typography>
                                <Typography variant="body2"><strong>Timezone:</strong> {result.data.time_zone}</Typography>
                            </Box>
                        </>
                      )}
                      {/* Display Channel List */}
                      {result.channel_list && result.channel_list.length > 0 && (
                        <>
                          <Typography variant="body2" color="textSecondary">
                              Channel List Info
                          </Typography>
                          <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                              <Table>
                                  <TableHead>
                                      <TableRow>
                                          <TableCell>Channel ID</TableCell>
                                          <TableCell>Channel Name</TableCell>
                                          <TableCell>Main Stream Bit Rate</TableCell>
                                          <TableCell>Main Stream Resolution</TableCell>
                                          <TableCell>Recording Days</TableCell>
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                      {result.channel_list.map((channel) => (
                                          <TableRow key={channel.channel_id}>
                                              <TableCell>{channel.channel_id}</TableCell>
                                              <TableCell>{channel.channel_name}</TableCell>
                                              <TableCell>{channel.main_stream_bit_rate}</TableCell>
                                              <TableCell>{channel.main_stream_resolution}</TableCell>
                                              <TableCell>{channel.recording_days}</TableCell>
                                          </TableRow>
                                      ))}
                                  </TableBody>
                              </Table>
                          </TableContainer>
                        </>
                      )}
                      {result?.result?.snapshot_info?.length > 0 && (
                        <>
                          <Typography variant="body2" color="textSecondary">
                              Snapshot Information
                          </Typography>
                          {result.result.snapshot_info.map((info, index) => (
                            <Box key={index}>
                            <Typography variant="body2">{info}</Typography>
                            </Box>
                          ))}
                        </>
                      )}
                  </Box>
              ))}
            </div>
            </div>
          )}
        </div>

        {/* Backdrop with Circular Progress */}
        <Backdrop
          open={this.state.open_progress_bar}
          style={{ zIndex: "1600" }}
        >
          <div className="custom-spinner">
            <div className="circle"></div>
            <div className="circle tilted"></div>
            <img
              src={WebLogo}
              alt="web-logo"
              style={{ backgroundColor: "#001f54", borderRadius: "100px" }}
            />
          </div>
               {" "}
        </Backdrop>
        <DialogBox
          confirmDialog={confirmDialog}
          setConfirmDialog={(updatedDialog) =>
            this.setState({ confirmDialog: updatedDialog })
          }
          onConfirm={this.state.confirmDialog.onConfirm} // Use the stored callback
          onCancel={this.closeDialog}
        />
      </div>
    );
  }
}

export default withNavigate(ShowDevices);